import { featureAccess } from '@/utils/accesses'

export const ScoringFormulaList = [
    {
        label: 'Industry Standards',
        key: 'Series'
    },
    {
        label: 'Sensitive',
        key: 'Sensitive'
    },
    // {
    //     label: 'Default',
    //     key: 'Default'
    // },
]

export const Roles = [
  {
    label: 'Admin',
    value: 'admin'
  },
  {
    label: 'Sales Manager',
    value: 'sales-manager'
  },
  {
    label: featureAccess('PERMISSION_MANAGER') ? 'Org admin' : 'Regular user',
    value: featureAccess('PERMISSION_MANAGER') ? 'organization-admin' : 'customer'
  },
]

export const sinteticsForExcludingTxTree = [
  'small transactions',
  'maximum depth reached'
]
